module.exports = __webpack_public_path__ + "static/media/pan-antano-140g-b.f6779426.webp";